<i [class]="'icon fa-regular fa-' + (icon() || defaultIcon())"></i>
<span class="text">
    @if (title()) {
        <b>{{ title() }}</b>
    }
    <ng-content></ng-content>
</span>
<span class="actions"><ng-content select="[actions]"></ng-content></span>
